module.exports = __webpack_public_path__ + "img/moonarch-logo-big.43aa5af9.svg";